// import { useState, useRef, useEffect } from "react";
// import {
//   motion,
//   AnimatePresence,
//   useMotionValue,
//   useSpring,
//   useTransform,
//   useMotionTemplate,
// } from "motion/react";
// import confetti from "canvas-confetti";
// import {
//   CircleDashed,
//   Clock,
//   Search,
//   CheckCircle2,
//   ChevronDown,
//   Check,
//   Activity,
//   FileText,
//   Calendar,
//   Sparkles,
// } from "lucide-react";
// import { ReactComponent as UnderReview } from "../../src/assets/new-images/Time.svg";
// import { ReactComponent as Closed } from "../../src/assets/new-images/Closed.svg";
// import { ReactComponent as Progress } from "../../src/assets/new-images/InProgress.svg";
// import { ReactComponent as Todo } from "../../src/assets/new-images/Todo.svg";

// const statuses = [
//   {
//     id: "todo",
//     label: "To Do",
//     icon: Todo,
//     color: "text-slate-500",
//     bg: "bg-gray-100",
//     border: "border-slate-200",
//     lightBg: "bg-slate-50",
//   },
//   {
//     id: "in_progress",
//     label: "In Progress",
//     icon: Progress,
//     color: "text-[#093A5B]",
//     bg: "bg-yellow-50",
//     border: "border-[#093A5B]/20",
//     lightBg: "bg-[#093A5B]/5",
//   },
//   {
//     id: "under_review",
//     label: "Under Review",
//     icon: UnderReview,
//     color: "text-amber-600",
//     // bg: "bg-amber-100",
//     bg: "bg-orange-50",
//     border: "border-amber-200",
//     lightBg: "bg-amber-50",
//   },
//   {
//     id: "closed",
//     label: "Closed",
//     icon: Closed,
//     color: "text-emerald-600",
//     bg: "bg-green-100",
//     border: "border-emerald-200",
//     lightBg: "bg-emerald-50",
//   },
// ];
// export default function TaskStand() {
//   const [activeStatus, setActiveStatus] = useState(statuses[1]); // Default to "In Progress"
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   // Hollywood 3D Hover & Lighting Logic
//   const cardRef = useRef(null);

//   const mouseX = useMotionValue(0);
//   const mouseY = useMotionValue(0);

//   const springConfig = { damping: 25, stiffness: 200 };
//   const springX = useSpring(mouseX, springConfig);
//   const springY = useSpring(mouseY, springConfig);

//   const rotateX = useTransform(springY, [-1, 1], [15, -15]);
//   const rotateY = useTransform(springX, [-1, 1], [-15, 15]);

//   const glareX = useTransform(springX, [-1, 1], [100, 0]);
//   const glareY = useTransform(springY, [-1, 1], [100, 0]);
//   const background = useMotionTemplate`radial-gradient(350px circle at ${glareX}% ${glareY}%, rgba(255, 255, 255, 0.7), transparent 60%)`;

//   // Handle clicking outside to close the dropdown properly
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsDropdownOpen(false);
//       }
//     };

//     if (isDropdownOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [isDropdownOpen]);

//   // Flatten the 3D card when dropdown opens so it's easy to click items
//   useEffect(() => {
//     if (isDropdownOpen) {
//       springX.set(0);
//       springY.set(0);
//     }
//   }, [isDropdownOpen, springX, springY]);

//   const handleMouseMove = (e) => {
//     if (!cardRef.current || isDropdownOpen) return;
//     const rect = cardRef.current.getBoundingClientRect();

//     const x = (e.clientX - rect.left - rect.width / 2) / (rect.width / 2);
//     const y = (e.clientY - rect.top - rect.height / 2) / (rect.height / 2);

//     mouseX.set(x);
//     mouseY.set(y);
//   };

//   const handleMouseLeave = () => {
//     if (isDropdownOpen) return;
//     mouseX.set(0);
//     mouseY.set(0);
//   };

//   const handleStatusSelect = (e, status) => {
//     e.stopPropagation(); // Stop propagation
//     setActiveStatus(status);
//     setIsDropdownOpen(false);

//     if (status.id === "closed") {
//       // Hollywood Confetti Blast
//       const duration = 2500;
//       const end = Date.now() + duration;

//       const frame = () => {
//         confetti({
//           particleCount: 8,
//           angle: 60,
//           spread: 55,
//           origin: { x: 0.2, y: 0.8 },
//           colors: ["#093A5B", "#10B981", "#F59E0B"],
//           zIndex: 1000,
//         });
//         confetti({
//           particleCount: 8,
//           angle: 120,
//           spread: 55,
//           origin: { x: 0.8, y: 0.8 },
//           colors: ["#093A5B", "#10B981", "#38BDF8"],
//           zIndex: 1000,
//         });

//         if (Date.now() < end) {
//           requestAnimationFrame(frame);
//         }
//       };
//       frame();
//     }
//   };
//   return (
//     <section className="TaskStatusSection">
//       <div className="TaskStatusContainer">
//         <div className="TaskStatusGrid">
//           {/* Left Content */}
//           <motion.div
//             initial={{ opacity: 0, x: -30 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true, margin: "-100px" }}
//             transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
//             className="TaskStatusLeft"
//           >
//             <div className="TaskStatusBadge">
//               <Activity className="TaskStatusBadgeIcon" />
//               <span>REAL-TIME TRACKING</span>
//             </div>

//             <h2 className="TaskStatusTitle">
//               Know exactly where <br />
//               <span className="TaskStatusTitleHighlight">
//                 every task stands.
//               </span>
//             </h2>

//             <p className="TaskStatusDescription">
//               No more guessing games. Update task statuses with a single click,
//               triggering automated notifications to your clients and team
//               members instantly.
//             </p>

//             <div className="TaskStatusList">
//               {statuses.map((status, idx) => (
//                 <motion.div
//                   key={status.id}
//                   initial={{ opacity: 0, y: 10 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: 0.2 + idx * 0.1 }}
//                   className="TaskStatusItem"
//                 >
//                   <div
//                     className={`TaskStatusIcon ${activeStatus.id === status.id ? status.bg : "TaskStatusIconDefault"}`}
//                   >
//                     <status.icon
//                       className={`TaskStatusIconSvg ${activeStatus.id === status.id ? status.color : "TaskStatusIconInactive"}`}
//                       strokeWidth={2}
//                     />
//                   </div>

//                   <span
//                     className={`TaskStatusLabel ${activeStatus.id === status.id ? "TaskStatusLabelActive" : ""}`}
//                   >
//                     {status.label}
//                   </span>
//                 </motion.div>
//               ))}
//             </div>
//           </motion.div>

//           {/* Right Interactive Card */}
//           <div className="TaskStatusDemo">
//             <div className="TaskStatusDemoBg" />
//             <div className="TaskStatusGlow" />

//             <motion.div
//               initial={{
//                 opacity: 0,
//                 y: 150,
//                 z: -400,
//                 rotateX: 60,
//                 rotateY: -30,
//                 scale: 0.8,
//               }}
//               whileInView={{
//                 opacity: 1,
//                 y: 0,
//                 z: 0,
//                 rotateX: 0,
//                 rotateY: 0,
//                 scale: 1,
//               }}
//               viewport={{ once: true, margin: "-100px" }}
//               transition={{
//                 duration: 1.4,
//                 ease: [0.16, 1, 0.3, 1],
//                 type: "spring",
//                 bounce: 0.25,
//               }}
//               className="TaskStatusCardWrapper"
//             >
//               <motion.div
//                 ref={cardRef}
//                 // onMouseMove={handleMouseMove}
//                 // onMouseLeave={handleMouseLeave}
//                 style={{ rotateX, rotateY }}
//                 className="TaskStatusCard"
//               >
//                 <motion.div
//                   className="TaskStatusCardGlare"
//                   style={{ background }}
//                 />

//                 <div className="TaskStatusCardContent">
//                   {/* Header */}
//                   <div className="TaskStatusHeader">
//                     <div>
//                       <div className="TaskStatusHeaderLabel">
//                         <FileText className="TaskStatusHeaderIcon" />
//                         <span>Tax Audit</span>
//                       </div>

//                       <h3 className="TaskStatusCardTitle">
//                         Annual Corporate Filing <br /> for Acme Corp
//                       </h3>
//                     </div>

//                     <div className="TaskStatusAvatar">
//                       <div className="TaskStatusAvatarGradient" />
//                     </div>
//                   </div>

//                   <div className="TaskStatusMeta">
//                     <Calendar className="TaskStatusMetaIcon" />
//                     <span>Due Oct 31</span>
//                   </div>

//                   {/* Status Dropdown */}
//                   <div className="TaskStatusDropdownSection">
//                     <label className="TaskStatusDropdownLabel">
//                       Update Status
//                     </label>

//                     <div
//                       className="TaskStatusDropdownWrapper"
//                       ref={dropdownRef}
//                     >
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setIsDropdownOpen(!isDropdownOpen);
//                         }}
//                         className={`TaskStatusDropdownButton ${isDropdownOpen ? "bg-gray-500" : "bg-white"} `}
//                       >
//                         <div className="TaskStatusDropdownButtonLeft">
//                           <div
//                             className={`TaskStatusDropdownIcon ${activeStatus.bg}`}
//                           >
//                             <activeStatus.icon
//                               className={`TaskStatusDropdownIconSvg ${activeStatus.color}`}
//                               strokeWidth={2.5}
//                             />
//                           </div>

//                           <span
//                             className={`TaskStatusDropdownLabelText ${activeStatus.color}`}
//                           >
//                             {activeStatus.label}
//                           </span>
//                         </div>

//                         <ChevronDown
//                           className={`TaskStatusChevron ${isDropdownOpen ? "TaskStatusChevronOpen" : ""}`}
//                         />
//                       </button>

//                       <AnimatePresence>
//                         {isDropdownOpen && (
//                           <motion.div
//                             initial={{ opacity: 0, y: -20 }}
//                             animate={{ opacity: 1, y: 0 }}
//                             exit={{ opacity: 0, y: -10 }}
//                             transition={{ duration: 0.3 }}
//                             className="TaskStatusDropdownMenu"
//                           >
//                             {statuses.map((status) => (
//                               <button
//                                 key={status.id}
//                                 onClick={(e) => handleStatusSelect(e, status)}
//                                 className="TaskStatusDropdownItem"
//                               >
//                                 <div className="TaskStatusDropdownItemLeft">
//                                   <status.icon
//                                     className={`TaskStatusDropdownItemIcon${status.color}`}
//                                     strokeWidth={2.5}
//                                   />

//                                   <span className="TaskStatusDropdownItemText">
//                                     {status.label}
//                                   </span>
//                                 </div>

//                                 {/* {activeStatus.id === status.id && (
//                                   <Check className="TaskStatusDropdownCheck" />
//                                 )} */}
//                               </button>
//                             ))}
//                           </motion.div>
//                         )}
//                       </AnimatePresence>
//                     </div>
//                   </div>
//                 </div>
//               </motion.div>
//             </motion.div>

//             <AnimatePresence>
//               {activeStatus.id === "closed" && (
//                 <motion.div
//                   initial={{ opacity: 0, scale: 0 }}
//                   animate={{ opacity: 1, scale: 1 }}
//                   exit={{ opacity: 0, scale: 0 }}
//                   className="TaskStatusNotification"
//                 >
//                   <Sparkles className="TaskStatusNotificationIcon" />
//                   <span>Client Notified!</span>
//                 </motion.div>
//               )}
//             </AnimatePresence>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

import { useState, useRef, useEffect } from "react";
import {
  motion,
  AnimatePresence,
  useMotionValue,
  useSpring,
  useTransform,
  useMotionTemplate,
} from "motion/react";
import confetti from "canvas-confetti";
import {
  CircleDashed,
  Clock,
  Search,
  CheckCircle2,
  ChevronDown,
  Check,
  Activity,
  FileText,
  Calendar,
  Sparkles,
} from "lucide-react";
import { ReactComponent as UnderReview } from "../../src/assets/new-images/Time.svg";
import { ReactComponent as Closed } from "../../src/assets/new-images/Closed.svg";
import { ReactComponent as Progress } from "../../src/assets/new-images/InProgress.svg";
import { ReactComponent as Todo } from "../../src/assets/new-images/Todo.svg";

const statuses = [
  {
    id: "todo",
    label: "To Do",
    icon: Todo,
    color: "text-slate-500",
    bg: "bg-gray-100",
    border: "border-slate-200",
    lightBg: "bg-slate-50",
  },
  {
    id: "in_progress",
    label: "In Progress",
    icon: Progress,
    color: "text-[#093A5B]",
    bg: "bg-yellow-50",
    border: "border-[#093A5B]/20",
    lightBg: "bg-[#093A5B]/5",
  },
  {
    id: "under_review",
    label: "Under Review",
    icon: UnderReview,
    color: "text-amber-600",
    bg: "bg-orange-50",
    border: "border-amber-200",
    lightBg: "bg-amber-50",
  },
  {
    id: "closed",
    label: "Closed",
    icon: Closed,
    color: "text-emerald-600",
    bg: "bg-green-100",
    border: "border-emerald-200",
    lightBg: "bg-emerald-50",
  },
];

export default function TaskStand() {
  const [activeStatus, setActiveStatus] = useState(statuses[1]); // Default to "In Progress"
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Hollywood 3D Hover & Lighting Logic
  const cardRef = useRef(null);

  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  const springConfig = { damping: 25, stiffness: 200 };
  const springX = useSpring(mouseX, springConfig);
  const springY = useSpring(mouseY, springConfig);

  const rotateX = useTransform(springY, [-1, 1], [15, -15]);
  const rotateY = useTransform(springX, [-1, 1], [-15, 15]);

  const glareX = useTransform(springX, [-1, 1], [100, 0]);
  const glareY = useTransform(springY, [-1, 1], [100, 0]);
  const background = useMotionTemplate`radial-gradient(350px circle at ${glareX}% ${glareY}%, rgba(255, 255, 255, 0.7), transparent 60%)`;

  // Handle clicking outside to close the dropdown properly
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownOpen]);

  // Flatten the 3D card when dropdown opens so it's easy to click items
  useEffect(() => {
    if (isDropdownOpen) {
      springX.set(0);
      springY.set(0);
    }
  }, [isDropdownOpen, springX, springY]);

  const handleMouseMove = (e) => {
    if (!cardRef.current || isDropdownOpen) return;
    const rect = cardRef.current.getBoundingClientRect();

    const x = (e.clientX - rect.left - rect.width / 2) / (rect.width / 2);
    const y = (e.clientY - rect.top - rect.height / 2) / (rect.height / 2);

    mouseX.set(x);
    mouseY.set(y);
  };

  const handleMouseLeave = () => {
    if (isDropdownOpen) return;
    mouseX.set(0);
    mouseY.set(0);
  };

  const handleStatusSelect = (e, status) => {
    e.stopPropagation();
    setActiveStatus(status);
    setIsDropdownOpen(false);

    if (status.id === "closed") {
      // Hollywood Confetti Blast
      const duration = 2500;
      const end = Date.now() + duration;

      const frame = () => {
        // confetti({
        //   // particleCount: 8,
        //   // angle: 60,
        //   // spread: 55,
        //   // origin: { x: 0.2, y: 0.8 },
        //   // colors: ["#093A5B", "#10B981", "#F59E0B"],
        //   // zIndex: 1000,
        //   particleCount: 5,
        //   spread: 360,
        //   startVelocity: 45,
        //   // origin: { x, y },
        //   origin: { x: 0.2, y: 0.8 },
        // });
        confetti({
          // particleCount: 8,
          // angle: 120,
          // spread: 55,
          // origin: { x: 0.8, y: 0.8 },
          // colors: ["#093A5B", "#10B981", "#38BDF8"],
          // zIndex: 1000,
          particleCount: 5,
          spread: 60,
          startVelocity: 45,
          // origin: { x, y },
          origin: { x: 0.8, y: 0.6 },
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      };
      frame();
    }
  };
  

  return (
    <section className="TaskStatusSection">
      <div className="TaskStatusContainer">
        <div className="TaskStatusGrid">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="TaskStatusLeft"
          >
            <div className="TaskStatusBadge">
              <Activity className="TaskStatusBadgeIcon" />
              <span className="TaskStatusBadge-text">REAL-TIME TRACKING</span>
            </div>

            <h2 className="TaskStatusTitle">
              Know exactly where <br />
              <span className="TaskStatusTitleHighlight">
                every task stands.
              </span>
            </h2>

            <p className="TaskStatusDescription">
              No more guessing games. Update task statuses with a single click,
              triggering automated notifications to your clients and team
              members instantly.
            </p>

            <div className="TaskStatusList">
              {statuses.map((status, idx) => (
                <motion.div
                  key={status.id}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.2 + idx * 0.1 }}
                  className="TaskStatusItem"
                >
                  <div
                    className={`TaskStatusIcon ${activeStatus.id === status.id ? status.bg : "TaskStatusIconDefault"}`}
                  >
                    <status.icon
                      className={`TaskStatusIconSvg ${activeStatus.id === status.id ? status.color : "TaskStatusIconInactive"}`}
                      strokeWidth={2}
                    />
                  </div>

                  <span
                    className={`TaskStatusLabel ${activeStatus.id === status.id ? "TaskStatusLabelActive" : ""}`}
                  >
                    {status.label}
                  </span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right Interactive Card */}
          <div className="TaskStatusDemo">
            <div className="TaskStatusDemoBg" />
            <div className="TaskStatusGlow" />

            <motion.div
              initial={{
                opacity: 0,
                y: 150,
                z: -400,
                rotateX: 60,
                rotateY: -30,
                scale: 0.8,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
                z: 0,
                rotateX: 0,
                rotateY: 0,
                scale: 1,
              }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{
                duration: 1.4,
                ease: [0.16, 1, 0.3, 1],
                type: "spring",
                bounce: 0.25,
              }}
              className="TaskStatusCardWrapper"
            >
              <motion.div
                ref={cardRef}
                // onMouseMove={handleMouseMove}
                // onMouseLeave={handleMouseLeave}
                style={{
                  rotateX: isDropdownOpen ? 0 : rotateX,
                  rotateY: isDropdownOpen ? 0 : rotateY,
                  transition: "rotateX 0.3s ease-out, rotateY 0.3s ease-out",
                }}
                className="TaskStatusCard"
              >
                <motion.div
                  className="TaskStatusCardGlare"
                  style={{ background: isDropdownOpen ? "none" : background }}
                />

                <div className="TaskStatusCardContent">
                  {/* Header */}
                  <div className="TaskStatusHeader">
                    <div>
                      <div className="TaskStatusHeaderLabel">
                        <FileText className="TaskStatusHeaderIcon" />
                        <span>Tax Audit</span>
                      </div>

                      <h3 className="TaskStatusCardTitle">
                        Annual Corporate Filing <br /> for Acme Corp
                      </h3>
                    </div>

                    {/* <div className="TaskStatusAvatar"> */}
                      {/* <div className="TaskStatusAvatarGradient" /> */}
                    {/* </div> */}
                  </div>

                  <div className="TaskStatusMeta">
                    <Calendar className="TaskStatusMetaIcon" />
                    <span>Due Oct 31</span>
                  </div>

                  {/* Status Dropdown */}
                  <div className="TaskStatusDropdownSection">
                    <label className="TaskStatusDropdownLabel">
                      Update Status
                    </label>

                    <div
                      className="TaskStatusDropdownWrapper"
                      ref={dropdownRef}
                    >
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsDropdownOpen(!isDropdownOpen);
                        }}
                        className={`TaskStatusDropdownButton ${activeStatus.bg} ${isDropdownOpen ? "ring-2 ring-offset-2 ring-gray-300" : ""}`}
                      >
                        <div className="TaskStatusDropdownButtonLeft">
                          <div
                            className={`TaskStatusDropdownIcon ${activeStatus.bg}`}
                          >
                            <activeStatus.icon
                              className={`TaskStatusDropdownIconSvg ${activeStatus.color}`}
                              strokeWidth={2.5}
                            />
                          </div>

                          <span
                            className={`TaskStatusDropdownLabelText ${activeStatus.color}`}
                          >
                            {activeStatus.label}
                          </span>
                        </div>

                        <ChevronDown
                          className={`TaskStatusChevron ${isDropdownOpen ? "TaskStatusChevronOpen" : ""}`}
                        />
                      </button>

                      <AnimatePresence>
                        {isDropdownOpen && (
                          <motion.div
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.3 }}
                            className="TaskStatusDropdownMenu"
                          >
                            {statuses.map((status) => (
                              <button
                                key={status.id}
                                onClick={(e) => handleStatusSelect(e, status)}
                                className="TaskStatusDropdownItem"
                              >
                                <div className="TaskStatusDropdownItemLeft">
                                  <status.icon
                                    className={`TaskStatusDropdownItemIcon ${status.color}`}
                                    strokeWidth={2.5}
                                  />

                                  <span className="TaskStatusDropdownItemText">
                                    {status.label}
                                  </span>
                                </div>

                                {/* {activeStatus.id === status.id && (
                                  <Check className="TaskStatusDropdownCheck" />
                                )} */}
                              </button>
                            ))}
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  </div>
                </div>
              </motion.div>
            </motion.div>

            <AnimatePresence>
              {activeStatus.id === "closed" && (
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0 }}
                  className="TaskStatusNotification"
                >
                  <Sparkles className="TaskStatusNotificationIcon" />
                  <span>Client Notified!</span>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
}
